import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import routesConfig from "./routesConfig";
import Loader from "../components/Loader";

const AppRoutes = () => {
	const routes = useRoutes(routesConfig);

	return <Suspense fallback={<Loader />}>{routes}</Suspense>;
};

export default AppRoutes;
